export default __webpack_public_path__ + "static/media/savebuy.c23cf7e4.jpg";